export const recipesConfig = {
  range: {
    imageTypes: ['range-main-image', 'range-detail-1-image', 'range-detail-2-image'],
  },
  recipeDetailViews: ['detail', 'fineDineInDetail'],
}
